import {
  findElementByIdInShadowDom,
  findElementInShadowDom,
  findAllElementsInShadowDom,
} from './utils/render.js';

import scrollama from 'scrollama';
import { ai2htmlResize } from './utils/ai2html-resizer';
import isMobile from './utils/isMobile.js';

ai2htmlResize('#g-polar-swarm-box');

const scrollContainer = findElementByIdInShadowDom('scrolly');

const stepConfig = [
  // step 0
  // nothing happens
  {},
  // step 1:  In California, more than 36,000 species have been documented on the platform, the majority of which are plants.
  { text: '.g-anno0' },
  // step 2: Most species go unnoticed. 90% of species in the state have been observed fewer than 500 times.
  {
    text: '.g-anno1',
    pointer: '.g-polar-swarm-desktop-anno1',
    ring: '.g-polar-swarm-desktop-bold-ring-img',
  },
  // step 3: For every observation of a coast live oak or a California poppy or a ground squirrel...
  {
    text: '.g-anno2',
    pointer: '.g-polar-swarm-desktop-anno2',
  },
  // step 4:  With more than 126,000 confirmed identifications, the western fence lizard is, by a longshot, the center of attention.
  {
    text: '.g-anno3',
    pointer: '.g-polar-swarm-desktop-anno3',
    maskId: 'g-polar-swarm-blur',
  },
];

let isInitialized = false;
const annotations = [];

// Annotations will be a list of objects that look like so:
// annotations[step] = {
//   textNodes: null,
//   pointer: null,
//   ring:    null,
//   mask:    null,
// };

function initAnnotations() {
  if (isInitialized) return;

  const suffix = isMobile ? '-m' : '';

  // Run shadow-DOM lookups now that the component is mounted
  stepConfig.forEach((config, step) => {
    const textSelector =
      config.text === '.g-anno0' ? config.text : `${config.text}${suffix}`;

    const annotation = {
      textNodes: findAllElementsInShadowDom(textSelector),
    };

    if (config.pointer) {
      annotation.pointer = findElementInShadowDom(
        `${config.pointer}${suffix}-pointer-img`
      );
    }

    if (config.ring) {
      annotation.ring = findElementInShadowDom(config.ring);
    }

    if (config.maskId) {
      annotation.mask = findElementByIdInShadowDom(config.maskId);
    }

    annotations[step] = annotation;
  });
}

function hideAllAnnotations() {
  // Toggle everything off
  annotations.forEach((annotation, step) => {
    toggleAnno(step, false);
  });
}

function toggleAnno(step, visible) {
  const { textNodes, pointer, ring, mask } = annotations[step];

  if (textNodes && textNodes.length) {
    textNodes.forEach((t) => (t.style.display = visible ? 'block' : 'none'));
  }

  if (pointer) pointer.classList.toggle('show-anno', visible);
  if (ring) ring.classList.toggle('show-anno', visible);
  if (mask) mask.classList.toggle('fade-in', visible);
}

function handleStep({ index }) {
  initAnnotations();
  hideAllAnnotations();

  if (index > 0) {
    toggleAnno(index, true);
  }

  console.log(index);
}

window.onload = function () {
  const scroller = scrollama();
  scroller
    .setup({
      step: '.scene',
      offset: 0.5,
      debug: false,
      parent: scrollContainer,
    })
    .onStepEnter(handleStep);
  // .onStepExit(handleStep);
  window.addEventListener('resize', scroller.resize());
};
